import React from 'react'

interface BaseLogoProps extends React.SVGProps<SVGSVGElement> {
  height?: number
  width?: number
  fill?: string
}
interface NabooLogoProps extends BaseLogoProps {
  type?: 'verbose' | 'icon'
}

const NabooLogo = ({ type = 'verbose', ...props }: NabooLogoProps) => {
  return type === 'icon' ? (
    <NabooIcon {...props} />
  ) : (
    <NabooVerbose {...props} />
  )
}

const NabooIcon = (props: BaseLogoProps) => {
  return (
    <svg
      width={35}
      height={35}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19 9.5C19 14.7467 14.7467 19 9.5 19C4.25329 19 0 14.7467 0 9.5C0 4.25329 4.25329 0 9.5 0C14.7467 0 19 4.25329 19 9.5Z'
        fill='#EDF578'
      />
      <path
        d='M4.00511 10.2586C4.52246 10.2586 5.03981 10.2586 5.57283 10.2586C5.60696 10.4151 5.64109 10.5716 5.67626 10.7328C5.88876 11.5604 6.23272 12.0467 6.96637 12.5C7.01644 12.5322 7.06651 12.5645 7.1181 12.5977C7.69638 12.8175 8.50396 12.7639 9.08729 12.5808C9.80819 12.2191 10.2232 11.6988 10.49 10.953C10.5508 10.7251 10.5853 10.4911 10.6244 10.2586C11.1417 10.2586 11.6591 10.2586 12.1921 10.2586C12.159 11.2759 11.9393 12.0226 11.3212 12.8448C11.2619 12.9284 11.2026 13.012 11.1415 13.0981C10.8138 13.4808 10.3601 13.7153 9.92763 13.9655C9.79559 14.0429 9.79559 14.0429 9.6609 14.1218C8.57143 14.5577 7.43057 14.4942 6.3567 14.0517C5.20657 13.4766 4.57707 12.6173 4.0922 11.4655C3.96832 11.0471 4.00511 10.7242 4.00511 10.2586Z'
        fill='#1F1F1E'
      />
      <path
        d='M12.9338 6.15739C13.1292 6.28131 13.3139 6.41279 13.4986 6.55172C13.5884 6.61395 13.6782 6.67619 13.7707 6.7403C14.3956 7.27632 14.9357 8.23851 14.9999 9.05779C15.0008 9.28575 14.991 9.51371 14.9792 9.74138C14.4618 9.74138 13.9445 9.74138 13.4115 9.74138C13.3809 9.57247 13.3504 9.40356 13.3189 9.22953C13.1335 8.4515 12.7892 7.97212 12.1105 7.53771C11.4539 7.21545 10.6617 7.18972 9.96029 7.39426C9.78951 7.4743 9.6444 7.56219 9.49215 7.67241C9.4167 7.71864 9.34126 7.76487 9.26352 7.8125C8.70354 8.36677 8.47016 8.97743 8.3599 9.74138C7.84255 9.74138 7.32521 9.74138 6.79218 9.74138C6.83853 8.66322 7.02884 7.89068 7.75023 7.06896C7.80132 7.01029 7.8524 6.95161 7.90503 6.89116C9.17824 5.53044 11.3087 5.24575 12.9338 6.15739Z'
        fill='#1E1E1E'
      />
      <path
        d='M13.4115 10.2586C13.9288 10.2586 14.4462 10.2586 14.9792 10.2586C14.9792 11.8233 14.9792 13.3879 14.9792 15C14.4618 15 13.9445 15 13.4115 15C13.4115 13.4353 13.4115 11.8707 13.4115 10.2586Z'
        fill='#1D1D1E'
      />
      <path
        d='M4.0051 5C4.52245 5 5.0398 5 5.57283 5C5.57283 6.56465 5.57283 8.12931 5.57283 9.74138C5.05548 9.74138 4.53813 9.74138 4.0051 9.74138C4.0051 8.17672 4.0051 6.61207 4.0051 5Z'
        fill='#1D1D1E'
      />
    </svg>
  )
}

const NabooVerbose = (props: BaseLogoProps) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width='100'
      height={31}
      viewBox='0 0 5868.000000 1800.000000'
      preserveAspectRatio='xMidYMid meet'
      {...props}
    >
      <g
        transform='translate(0.000000,1800.000000) scale(0.100000,-0.100000)'
        fill={props.fill ?? 'currentColor'}
        stroke='none'
      >
        <path
          d='M25870 17928 c-693 -636 -1535 -1107 -2420 -1358 -127 -35 -395 -98
-492 -115 l-38 -6 0 -8114 0 -8115 1510 0 1510 0 0 2132 c0 1178 4 2128 9
2123 4 -6 16 -66 25 -135 83 -605 265 -1300 489 -1864 514 -1299 1310 -2121
2301 -2381 444 -116 962 -121 1513 -14 1153 224 2166 977 2845 2114 645 1081
982 2487 955 3985 -10 511 -43 890 -117 1355 -289 1795 -1097 3178 -2287 3911
-523 322 -1100 515 -1733 578 -685 69 -1246 -17 -1755 -268 -487 -241 -887
-601 -1231 -1111 -481 -712 -829 -1720 -984 -2850 -6 -44 -14 -91 -18 -105 -4
-14 -9 2298 -12 5136 l-5 5161 -65 -59z m3005 -6333 c473 -83 918 -509 1273
-1220 435 -871 687 -2031 774 -3560 16 -289 16 -1291 0 -1585 -85 -1514 -325
-2649 -746 -3515 -186 -383 -370 -650 -602 -876 -205 -198 -402 -314 -631
-371 -114 -28 -325 -30 -456 -5 -986 195 -1859 1427 -2266 3197 -171 743 -251
1506 -251 2385 1 2434 598 4295 1653 5148 378 306 879 467 1252 402z'
        />
        <path
          d='M6651 12040 c-870 -50 -1539 -279 -2110 -723 -135 -105 -372 -341
-485 -482 -103 -129 -269 -377 -351 -524 -290 -522 -504 -1184 -635 -1966 -22
-132 -42 -244 -44 -250 -3 -5 -5 858 -5 1918 l-1 1929 -60 -54 c-376 -334
-620 -516 -986 -736 -569 -342 -1256 -605 -1839 -704 l-135 -23 0 -5102 0
-5103 1510 0 1510 0 0 3353 c0 2863 2 3383 15 3562 124 1757 560 3045 1275
3764 311 313 634 495 1029 578 112 24 148 27 331 27 177 0 219 -3 310 -22 144
-32 287 -90 400 -163 123 -79 284 -240 369 -369 244 -369 399 -928 465 -1680
39 -442 39 -408 43 -4782 l4 -4268 1520 0 1519 0 -3 3978 c-3 4290 0 4048 -52
4495 -173 1484 -735 2494 -1665 2989 -342 183 -731 296 -1178 343 -176 19
-553 26 -751 15z'
        />
        <path
          d='M16070 12013 c-667 -46 -1111 -126 -1610 -293 -834 -277 -1482 -730
-1868 -1305 -439 -653 -489 -1387 -141 -2084 113 -228 226 -395 407 -603 80
-93 86 -98 123 -98 23 0 41 5 43 13 2 6 16 91 31 187 108 709 302 1410 546
1974 523 1208 1307 1921 2291 2085 368 61 765 51 1075 -29 767 -198 1239 -812
1403 -1823 63 -386 72 -645 68 -1932 l-3 -1049 -1415 -152 c-778 -83 -1482
-161 -1565 -173 -1455 -209 -2579 -707 -3248 -1440 -601 -658 -848 -1505 -711
-2446 102 -703 374 -1286 814 -1739 477 -492 1124 -818 1955 -985 568 -114
1323 -149 1835 -86 1209 150 1968 835 2260 2039 38 154 90 443 90 495 0 59 13
1 30 -140 195 -1546 1012 -2298 2618 -2408 85 -6 205 -11 268 -11 l114 0 -3
4387 c-2 4144 -4 4396 -20 4528 -10 77 -29 201 -43 275 -258 1408 -1309 2312
-3094 2659 -407 79 -825 127 -1325 151 -188 9 -810 11 -925 3z m2368 -6808 c3
-1822 -1 -2081 -38 -2407 -164 -1434 -839 -2330 -1856 -2463 -452 -59 -808 49
-1111 338 -176 169 -287 326 -418 592 -206 419 -329 904 -397 1565 -21 201
-17 923 5 1130 87 795 305 1404 672 1877 431 557 1024 868 1835 963 96 11 384
47 640 80 614 78 611 78 640 76 l25 -1 3 -1750z'
        />
        <path
          d='M40505 11963 c-22 -1 -103 -7 -180 -13 -690 -53 -1429 -259 -2080
-581 -1145 -565 -2063 -1477 -2688 -2669 -950 -1812 -980 -3876 -81 -5609 197
-380 425 -722 710 -1066 136 -164 520 -549 683 -685 277 -229 661 -493 890
-609 l41 -22 20 47 c11 25 20 47 20 49 0 1 -39 31 -87 66 -117 84 -292 261
-375 379 -165 234 -273 518 -323 850 -35 230 -30 636 11 960 112 886 517 2103
1197 3600 794 1749 1495 2972 2163 3775 138 166 488 516 624 625 343 273 684
435 1035 492 183 29 465 11 664 -43 40 -11 75 -18 77 -17 1 2 12 24 22 49 l20
46 -126 45 c-528 189 -1005 290 -1562 328 -131 9 -576 11 -675 3z'
        />
        <path
          d='M52770 11964 c-423 -29 -761 -81 -1125 -174 -1568 -401 -2880 -1420
-3712 -2883 -977 -1719 -1116 -3696 -381 -5422 495 -1161 1369 -2143 2440
-2739 l67 -37 21 40 c11 22 20 44 20 49 0 5 -35 36 -77 68 -407 303 -627 695
-710 1259 -21 148 -24 601 -5 770 64 563 187 1084 418 1775 292 871 792 2035
1369 3185 576 1147 1080 1962 1590 2575 161 193 462 495 620 622 384 308 744
469 1135 508 173 18 425 -6 585 -55 28 -8 53 -15 57 -15 7 0 51 91 46 95 -2 2
-70 27 -153 57 -475 174 -988 280 -1535 318 -130 9 -555 11 -670 4z'
        />
        <path
          d='M43420 11270 c-13 -28 -22 -51 -19 -53 2 -2 40 -30 84 -62 44 -32
134 -112 201 -179 288 -289 449 -652 505 -1136 16 -136 16 -521 0 -675 -75
-730 -289 -1518 -696 -2565 -399 -1025 -1037 -2383 -1563 -3325 -643 -1153
-1261 -1951 -1851 -2388 -214 -159 -468 -290 -690 -356 -166 -50 -278 -65
-471 -65 -179 0 -267 11 -428 53 l-73 19 -25 -49 -24 -49 24 -10 c474 -180
929 -288 1456 -347 207 -23 899 -26 1100 -5 588 62 1112 188 1630 394 211 84
583 266 775 378 1181 694 2076 1761 2610 3109 211 533 348 1080 409 1631 54
481 45 1033 -25 1515 -151 1050 -600 2059 -1279 2875 -446 535 -948 953 -1581
1313 l-46 26 -23 -49z'
        />
        <path
          d='M55681 11268 c-18 -43 -19 -53 -7 -60 45 -26 204 -159 279 -235 279
-283 436 -632 499 -1113 16 -124 16 -581 0 -730 -108 -971 -491 -2159 -1215
-3760 -1233 -2729 -2271 -4225 -3272 -4715 -386 -190 -760 -239 -1145 -151
-58 13 -113 27 -123 31 -14 6 -21 -2 -38 -40 -12 -28 -17 -51 -12 -56 17 -17
285 -110 472 -164 314 -90 632 -152 991 -192 206 -23 899 -26 1100 -5 763 79
1421 268 2075 594 931 466 1725 1175 2307 2063 628 956 995 2032 1069 3128 23
354 4 876 -47 1227 -156 1088 -611 2096 -1332 2950 -123 146 -462 486 -612
614 -268 229 -600 460 -911 634 l-56 32 -22 -52z'
        />
      </g>
    </svg>
  )
}

export default NabooLogo
